import configs from "configs"
import constantImages from "./img.constant"

const HOME_DATA = {
    Title: 'Welcome to My Portfolio',
    Content: 'Where you are is a result of who you were, but where you go depends entirely on who you choose to be.',
    socials: [
        {
            link: 'mailto:cman40285@gmail.com',
            icon: 'email'
        },
        {
            link: 'https://github.com/OHANA-WEB',
            icon: 'github'
        },
        // {
        //     link: 'https://www.freelancer.com/u/TomaK01',
        //     icon: 'freelancer'
        // },
        {
            link: 'https://www.chatwork.com/MARISAKI',
            icon: 'chatwork'
        },
        {
            link: 'https://crowdworks.jp/public/employees/6564108',
            icon: 'crowdworks'
        },
    ]
}

const ABOUT_DATA = {
    SERVICES: [
        {
            id: 'item-0',
            content: 'Website Development',
            icon: 'website',
            description: 'Develop websites including Ecommerce, SaaS, and landing pages.',
            year: '4'
        },
        {
            id: 'item-1',
            content: 'Website Design',
            icon: 'design',
            description: 'Carry out UI/UX design for all environments of the website, including desktop, tablet, and mobile.',
            year: '4'
        },
        {
            id: 'item-2',
            content: 'Dapp Development',
            icon: 'card',
            description: 'Provide development of Crypto-related projects including NFT Marketplace, Defi, and Game.',
            year: '3'
        },
        {
            id: 'item-3',
            content: 'Bot Development',
            icon: 'bot',
            description: 'Provide Bot development services such as Telegram Bot, Discord Bot, and Automate Bot.',
            year: '3'
        }
    ],
    SKILLS: [
        {
            id: 'item-0',
            content: 'HTML',
            icon: 'html',
            description: 'It is the standard language used to create and design web pages.',
            year: '4',
            type: 'Frontend'
        },
        {
            id: 'item-1',
            content: 'CSS',
            icon: 'css',
            description: "It's a style sheet language used for describing the presentation of a document written in HTML or XML",
            year: '4',
            type: 'Frontend'
        },
        {
            id: 'item-2',
            content: 'JavaScript',
            icon: 'js',
            description: 'JavaScript is a programming language commonly used to create interactive effects within web browsers.',
            year: '4',
            type: 'Frontend'
        },
        {
            id: 'item-3',
            content: 'TypeScript',
            icon: 'ts',
            description: 'It is a superset of JavaScript that adds static typing features in addition to the features already present in JavaScript. ',
            year: '3',
            type: 'Frontend'
        },
        {
            id: 'item-4',
            content: 'React',
            icon: 'react',
            description: 'React is a popular JavaScript library used for building user interfaces for web applications. ',
            year: '3',
            type: 'Frontend'
        },
        {
            id: 'item-5',
            content: 'Node.js',
            icon: 'node',
            description: 'Node.js is an open-source, cross-platform JavaScript runtime environment that allows developers to build scalable network applications.',
            year: '4',
            type: 'Backend'
        }
    ],
    DESIGNS: [
        {
            id: 'item-0',
            content: 'Adobe Animate',
            icon: 'aa',
            description: 'It is used to design vector graphics and create animations for various media, including television series, online animation, websites, web applications, game development, commercials, and other interactive projects',
            year: '4',
            type: 'Design'
        },
        {
            id: 'item-1',
            content: 'Adobe XD',
            icon: 'ax',
            description: 'It is specifically designed for creating and prototyping user interfaces (UI) and user experiences (UX) for websites, mobile apps, and other digital platforms',
            year: '4',
            type: 'Design'
        },
        {
            id: 'item-2',
            content: 'Adobe Illustrator',
            icon: 'ai',
            description: 'It is widely used by graphic designers, web designers, visual artists, and professional illustrators to create high-quality artwork, illustrations, logos, icons, patterns, and more.',
            year: '4',
            type: 'Design'
        },
        {
            id: 'item-3',
            content: 'Figma',
            icon: 'figma',
            description: 'It is primarily used for creating user interfaces (UI) and user experiences (UX) for websites, mobile apps, and other digital products.',
            year: '4',
            type: 'Design'
        },
    ],
    EDITORS: [
        {
            id: 'item-0',
            content: 'VS Code',
            icon: 'vscode',
            description: ' It is designed to provide a lightweight yet powerful environment for editing, debugging, and building modern web and cloud applications',
            type: 'Editor'
        },
        {
            id: 'item-1',
            content: 'CodePen',
            icon: 'code_pen',
            description: 'It provides a platform for developers to write, test, and share HTML, CSS, and JavaScript code snippets, projects, and web applications.',
            type: 'Editor'
        },
    ],
    UTILS: [
        {
            id: 'item-0',
            content: 'Git',
            icon: 'git',
            description: 'Git is a distributed version control system used for tracking changes in source code during software development. ',
            type: 'Util'
        },
        {
            id: 'item-1',
            content: 'NPM',
            icon: 'npm',
            description: 'npm (Node Package Manager) is a package manager for JavaScript programming language. ',
            type: 'Util'
        },
        {
            id: 'item-2',
            content: 'Yarn',
            icon: 'yarn',
            description: 'Yarn is a package manager for JavaScript, just like npm.',
            type: 'Util'
        },
    ],
    DATABASE: [
        {
            id: 'item-0',
            content: 'MySQL',
            icon: 'mysql',
            description: 'MySQL is an open-source relational database management system.',
            type: 'database',
            year: '4'
        },
        {
            id: 'item-1',
            content: 'PostgreSQL',
            icon: 'postgresql',
            description: 'PostgreSQL is an open-source relational database management system known for its robustness, reliability, and ability to handle complex workloads',
            type: 'database',
            year: '4'
        },
        {
            id: 'item-2',
            content: 'MongoDB',
            icon: 'mongodb',
            description: 'MongoDB is a cross-platform document-oriented database program.',
            type: 'database',
            year: '4'
        },
        {
            id: 'item-3',
            content: 'Firebase',
            icon: 'firebase',
            description: 'Firebase is a mobile and web application development platform developed by Google.',
            type: 'database',
            year: '4'
        },
    ],
    HOSTING: [
        {
            id: 'item-0',
            content: 'Heroku',
            icon: 'heroku',
            description: 'Heroku is a cloud-based platform as a service (PaaS) that enables developers to deploy, manage, and scale applications.',
            type: 'Hosting',
        },
        {
            id: 'item-1',
            content: 'Vercel',
            icon: 'vercel',
            description: 'Vercel is a cloud platform that enables developers to create, deploy, and scale web applications.',
            type: 'Hosting',
        },
        {
            id: 'item-2',
            content: 'AWS',
            icon: 'aws',
            description: 'AWS (Amazon Web Services) is a comprehensive and widely used cloud computing platform offered by Amazon.',
            type: 'Hosting',
        },
        {
            id: 'item-3',
            content: 'DigitalOcean',
            icon: 'digital_ocean',
            description: 'DigitalOcean is a cloud computing platform that offers infrastructure hosting services for developers.',
            type: 'Hosting',
        },
    ]
}

const MENU_DATA = [
    {
        link: configs.path.HOME_PREFIX,
        content: 'Home'
    },
    {
        link: configs.path.OVERVIEW_PREFIX,
        content: 'Overview'
    },
    {
        link: configs.path.SKILLS_PREFIX,
        content: 'Skills'
    },
    {
        link: configs.path.WORKS_PREFIX,
        content: 'Projects'
    },
    {
        link: configs.path.CONTACT_PREFIX,
        content: 'Contact'
    },
]

const OVERVIEW_DATA = {
    PIE_DATA: [
        { name: 'Design', value: 600 },
        { name: 'Frontend', value: 800 },
        { name: 'Backend', value: 226 },
        { name: 'Bot', value: 300 },
        { name: 'Dapp', value: 400 },
        { name: 'AI', value: 200 },
        { name: 'Mobile', value: 320 },
        { name: 'Bug Fix', value: 156 },
        { name: 'API', value: 236 },
    ],
    LINE_DATA: [
        {
            name: 'Page A',
            uv: 4000,
            pv: 2400,
            amt: 2400,
        },
        {
            name: 'Page B',
            uv: 3000,
            pv: 1398,
            amt: 2210,
        },
        {
            name: 'Page C',
            uv: 2000,
            pv: 9800,
            amt: 2290,
        },
        {
            name: 'Page D',
            pv: 3908,
            amt: 2000,
        },
        {
            name: 'Page E',
            uv: 1890,
            pv: 4800,
            amt: 2181,
        },
        {
            name: 'Page F',
            uv: 2390,
            pv: 3800,
            amt: 2500,
        },
        {
            name: 'Page G',
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ],
    BAR_DATA: [
        { name: 'Design', value: 600 },
        { name: 'Frontend', value: 800 },
        { name: 'Backend', value: 226 },
        { name: 'Bot', value: 300 },
        { name: 'Dapp', value: 400 },
        { name: 'AI', value: 200 },
        { name: 'Mobile', value: 320 },
        { name: 'Bug Fix', value: 156 },
        { name: 'API', value: 236 },
    ],
    COLORS: ['#f44336', '#8a4af3', '#2196f3', '#009688', '#FA6800', '#795548', '#ffeb3b', '#8bc34a', '#cddc39', '#f44336'],
    PERSONAL_DATA: {
        NAME: 'MORISAKI',
        USERNAME: '000hiruko000',
        PRONOUNCE: 'He/Him',
        INFORMATION: [
            {
                icon: 'location',
                value: 'Japan',
                link: '#'
            },
            {
                icon: 'blog',
                value: '12 BLogs',
                link: '#'
            },
            {
                icon: 'status',
                value: 'Available For Hire',
                link: '#'
            },
            {
                icon: 'users',
                value: '19.4K Design Users',
                link: '#'
            }
        ]
    },
    AGGREGATE_DATA: [
        {
            icon: 'calendar',
            value: 'Experience',
            count: '15+ years'
        },
        {
            icon: 'website',
            value: 'Projects',
            count: '56'
        },
        {
            icon: 'github',
            value: 'Repositories',
            count: '155'
        },
        {
            icon: 'good',
            value: 'Reviews',
            count: '35'
        }
    ]
}

const FRONTEND_DATA = [
    {
        description: 'Ceras Health is a healthcare company that provides innovative solutions for managing chronic conditions. ',
        name: 'CerasHealth',
        image: constantImages.CERASHEALTH,
        link: 'https://cerashealth.com'
    },
    {
        description: `Pickade is your destination for a modern Minecraft minigames experience. `,
        name: 'PicKade',
        image: constantImages.PICKADE,
        link: 'https://pickade.net/'
    },
    {
        description: 'CBET Casino is an online gambling platform that offers a wide range of casino games, including slots, table games, live dealer games, and more.',
        name: 'CBet',
        image: constantImages.CBET,
        link: 'https://cbet.world'
    },
    {
        description: 'A Raffle Famous  is an online platform where individuals can purchase tickets for a chance to win prizes. ',
        name: 'Raffle Famous',
        image: constantImages.RAFFLE,
        link: 'https://rafffle.famousfoxes.com/'
    },
    {
        description: 'Sportsblog is a platform where sports fans can write and share their thoughts, opinions, and analysis about various sports topics.',
        name: 'SportsBlog',
        image: constantImages.SPORTSBLOG,
        link: 'https://sportsblog.com/'
    },
    {
        description: 'AI-powered location technology for automakers, mobile app developers, and logistics services',
        name: 'MapBox',
        image: constantImages.MAPBOX,
        link: 'https://www.mapbox.com/'
    },
    {
        description: 'Bloxmoon is an online gambling platform that offers a wide range of casino games, including slots, table games, live dealer games, and more.',
        name: 'BloxMoon',
        image: constantImages.BLOXMOON,
        link: 'https://bloxmoon.com/'
    },
    {
        description: 'Armory is web3 community to get items !',
        name: 'ARMORY',
        image: constantImages.ARMORY,
        link: "https://cyberstadium.gg"
    },
    {
        description: 'Amino Rewards is a feature within the Amino app, a social networking healthy app for communities.',
        name: 'Amino Rewards',
        image: constantImages.AMINOREWARDS,
        link: "https://aminorewards.com/"
    },

]

const BACKEND_DATA = [
    {
        description: 'Ceras Health is a healthcare company that provides innovative solutions for managing chronic conditions. ',
        name: 'CerasHealth',
        image: constantImages.CERASHEALTH,
        link: 'https://cerashealth.com'
    },
    {
        description: 'A Raffle Famous  is an online platform where individuals can purchase tickets for a chance to win prizes. ',
        name: 'Raffle Famous',
        image: constantImages.RAFFLE,
        link: 'https://rafffle.famousfoxes.com/'
    },
    {
        description: 'Sportsblog is a platform where sports fans can write and share their thoughts, opinions, and analysis about various sports topics.',
        name: 'SportsBlog',
        image: constantImages.SPORTSBLOG,
        link: 'https://sportsblog.com/'
    },
    {
        description: 'Bloxmoon is an online gambling platform that offers a wide range of casino games, including slots, table games, live dealer games, and more.',
        name: 'BloxMoon',
        image: constantImages.BLOXMOON,
        link: 'https://bloxmoon.com/'
    },
    {
        description: 'Armory is web3 community to get items !',
        name: 'ARMORY',
        image: constantImages.ARMORY,
        link: "https://cyberstadium.gg"
    }
]

const FRONTEND_DATA_JA = [
    {
        description: '皮膚科専門医が開発したスキンケアブランドの公式サイト。',
        name: 'NUSET',
        image: constantImages.NUSET,
        link: 'https://nuset.jp/'
    },
    {
        description: '日本を代表する化粧品ブランドの公式サイト。',
        name: '資生堂',
        image: constantImages.SHISEIDO,
        link: 'https://www.shiseido.co.jp/'
    },
    {
        description: '京都の和菓子店「果朋」の公式サイト。',
        name: '果朋',
        image: constantImages.KAHOU,
        link: 'https://www.kahou.com/'
    },
    {
        description: '東京都内の歯科医院公式サイト。',
        name: 'YS歯科',
        image: constantImages.YS_DENTAL_CLINIC,
        link: 'https://www.ys-dc.jp/'
    },
    {
        description: '木製家具・インテリア雑貨製造販売企業のサイト。',
        name: 'Marimo Craft',
        image: constantImages.MARIMO_CRAFT,
        link: 'https://marimocraft.co.jp'
    },
    {
        description: '金属メッキ加工専門企業の公式サイト。',
        name: '浜岡メッキ',
        image: constantImages.HAMAOKA_MEKKI,
        link: 'https://hamaokamekki.co.jp/'
    },
    {
        description: '尺八・箏など伝統楽器の製造・販売サイト。',
        name: '春近',
        image: constantImages.HARUCHIKA_INSTRUMENTS,
        link: 'https://www.haruchika.co.jp/'
    },
    {
        description: 'コンテンツ制作・ライティングサービスを提供するサイト。',
        name: 'Re-Write',
        image: constantImages.REWRITE_SERVICE,
        link: 'https://www.re-write.llc/'
    },
    {
        description: '建築用シーリング材製造・販売企業のサイト。',
        name: 'Sunny Sealing',
        image: constantImages.SUNNY_SEALING,
        link: 'https://sunnysealing.jp/'
    },
]

const BACKEND_DATA_JA = [
    {
        description: '高品質食品・冷凍食品の宅配サービス公式サイト。',
        name: '食文',
        image: constantImages.SHOKUBUN,
        link: 'https://www.shokubun.co.jp'
    },
    {
        description: '不動産賃貸・売買情報ポータルサイト。',
        name: 'Free Location',
        image: constantImages.FREE_LOCATION,
        link: 'https://freelocation.co.jp/'
    },
    {
        description: '企業向け人材紹介・派遣サービスサイト。',
        name: 'Pro-D-Use',
        image: constantImages.PRO_D_USE,
        link: 'https://pro-d-use.jp/'
    },
    {
        description: 'プロジェクトマネジメント支援コンサルティング会社。',
        name: 'MSOLS',
        image: constantImages.MSOLS,
        link: 'https://www.msols.com/'
    },
    {
        description: 'リクルートグループの人材サービスサイト。',
        name: 'Recruit MS',
        image: constantImages.RECRUIT_MS,
        link: 'https://www.recruit-ms.co.jp/'
    },
    {
        description: '転職支援サービスを提供する企業サイト。',
        name: 'Career Scout',
        image: constantImages.CAREER_SCOUT,
        link: 'https://www.careerscout.co.jp/'
    },
    {
        description: 'IT技術を活用した事業開発企業の公式サイト。',
        name: 'Next Level Holdings',
        image: constantImages.NEXT_LEVEL_HOLDINGS,
        link: 'https://nextlevelholdings.co.jp/'
    },
    {
        description: '歯科医院向け患者管理システム提供企業。',
        name: 'Medento',
        image: constantImages.MEDENTO,
        link: 'https://www.medento.com/'
    },
    {
        description: 'AI活用の人材マッチングサービス企業サイト。',
        name: 'Givery',
        image: constantImages.GIVERY,
        link: 'https://givery.co.jp/'
    },
]


const constantData = {
    HOME_DATA,
    ABOUT_DATA,
    MENU_DATA,
    OVERVIEW_DATA,
    FRONTEND_DATA,
    BACKEND_DATA,
    FRONTEND_DATA_JA,
    BACKEND_DATA_JA
}

export default constantData;